import axios from 'axios'
import context from '../main.js'
import { Message } from 'element-ui'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 30000
})

// request interceptor
service.interceptors.request.use(
  config => {
    context.$loading.show()
    config.headers['Authorization'] = localStorage.getItem('token')
    return config
  },
  error => {
    console.log("1596141177149")
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    context.$loading.hide()
    const res = response.data
    if (res.code == 200){
      return res
    }else if (res.code == 500) {
      Message({
        message: res.msg,
        type: 'error',
        duration: 3 * 1000
      })
      
    } else{
      context.$router.push('/login')
    }
  },
  error => {
    context.$loading.hide()
    let message = '网络错误'
    if(error && error.response){
      switch(error.response.status){
        case 401:
          message = "用户名或密码错误"
          break
        case 404:
          message = "资源不存在"
          break;
        default:
          message = "服务器异常"
          break;
      }
    }else if(error.code == 'ECONNABORTED'){
      message = "访问超时"
    }
    Message({
        message: message,
        type: 'error',
        duration: 3 * 1000
      })
  }
)

export default service